// =============================================================
// Local Stock Database — ~500+ symbols for instant autocomplete
// Covers: S&P 500, Popular ETFs, Top Crypto, REITs, ADRs
// Last updated: 2026-04
// =============================================================
import { generateDatabaseAliases } from '../utils/symbolAlias';

export const STOCK_DATABASE = {
  // ========================
  // MEGA CAP TECH
  // ========================
  'AAPL': 'Apple Inc.',
  'MSFT': 'Microsoft Corp.',
  'GOOGL': 'Alphabet Inc. (Class A)',
  'GOOG': 'Alphabet Inc. (Class C)',
  'AMZN': 'Amazon.com Inc.',
  'META': 'Meta Platforms Inc.',
  'NVDA': 'NVIDIA Corp.',
  'TSLA': 'Tesla Inc.',
  'AVGO': 'Broadcom Inc.',
  'ORCL': 'Oracle Corp.',
  'ADBE': 'Adobe Inc.',
  'CRM': 'Salesforce Inc.',
  'CSCO': 'Cisco Systems Inc.',
  'ACN': 'Accenture plc',
  'IBM': 'IBM Corp.',
  'INTC': 'Intel Corp.',
  'AMD': 'Advanced Micro Devices',
  'QCOM': 'Qualcomm Inc.',
  'TXN': 'Texas Instruments',
  'NOW': 'ServiceNow Inc.',
  'INTU': 'Intuit Inc.',
  'AMAT': 'Applied Materials Inc.',
  'MU': 'Micron Technology',
  'LRCX': 'Lam Research Corp.',
  'KLAC': 'KLA Corp.',
  'SNPS': 'Synopsys Inc.',
  'CDNS': 'Cadence Design Systems',
  'MRVL': 'Marvell Technology',
  'NXPI': 'NXP Semiconductors',
  'MCHP': 'Microchip Technology',
  'ON': 'ON Semiconductor',
  'ADI': 'Analog Devices Inc.',
  'FTNT': 'Fortinet Inc.',
  'PANW': 'Palo Alto Networks',
  'CRWD': 'CrowdStrike Holdings',
  'ZS': 'Zscaler Inc.',
  'DDOG': 'Datadog Inc.',
  'NET': 'Cloudflare Inc.',
  'SNOW': 'Snowflake Inc.',
  'MDB': 'MongoDB Inc.',
  'PLTR': 'Palantir Technologies',
  'TEAM': 'Atlassian Corp.',
  'WDAY': 'Workday Inc.',
  'HUBS': 'HubSpot Inc.',
  'VEEV': 'Veeva Systems Inc.',
  'SPLK': 'Splunk Inc.',
  'ZM': 'Zoom Video Communications',
  'DOCU': 'DocuSign Inc.',
  'OKTA': 'Okta Inc.',
  'TWLO': 'Twilio Inc.',
  'SQ': 'Block Inc. (Square)',
  'COIN': 'Coinbase Global',
  'HOOD': 'Robinhood Markets',
  'SHOP': 'Shopify Inc.',
  'SE': 'Sea Limited',
  'GRAB': 'Grab Holdings',
  'SPOT': 'Spotify Technology',
  'PINS': 'Pinterest Inc.',
  'SNAP': 'Snap Inc.',
  'RBLX': 'Roblox Corp.',
  'U': 'Unity Software',
  'TTD': 'The Trade Desk',
  'APP': 'AppLovin Corp.',
  'DASH': 'DoorDash Inc.',

  // ========================
  // SEMICONDUCTORS & HARDWARE
  // ========================
  'TSM': 'Taiwan Semiconductor (TSMC)',
  'ASML': 'ASML Holding NV',
  'ARM': 'Arm Holdings plc',
  'SMCI': 'Super Micro Computer',
  'DELL': 'Dell Technologies',
  'HPE': 'Hewlett Packard Enterprise',
  'HPQ': 'HP Inc.',
  'STX': 'Seagate Technology',
  'WDC': 'Western Digital',
  'MPWR': 'Monolithic Power Systems',
  'SWKS': 'Skyworks Solutions',
  'QRVO': 'Qorvo Inc.',
  'GFS': 'GlobalFoundries Inc.',
  'WOLF': 'Wolfspeed Inc.',

  // ========================
  // AI & QUANTUM
  // ========================
  'IONQ': 'IonQ Inc.',
  'RGTI': 'Rigetti Computing',
  'QBTS': 'D-Wave Quantum',
  'AI': 'C3.ai Inc.',
  'BBAI': 'BigBear.ai Holdings',
  'SOUN': 'SoundHound AI',
  'UPST': 'Upstart Holdings',
  'PATH': 'UiPath Inc.',

  // ========================
  // FINANCE & BANKING
  // ========================
  'JPM': 'JPMorgan Chase & Co.',
  'V': 'Visa Inc.',
  'MA': 'Mastercard Inc.',
  'BAC': 'Bank of America Corp.',
  'WFC': 'Wells Fargo & Co.',
  'GS': 'Goldman Sachs Group',
  'MS': 'Morgan Stanley',
  'BLK': 'BlackRock Inc.',
  'SCHW': 'Charles Schwab Corp.',
  'C': 'Citigroup Inc.',
  'AXP': 'American Express Co.',
  'USB': 'U.S. Bancorp',
  'PNC': 'PNC Financial Services',
  'TFC': 'Truist Financial Corp.',
  'BK': 'Bank of New York Mellon',
  'STT': 'State Street Corp.',
  'COF': 'Capital One Financial',
  'CME': 'CME Group Inc.',
  'ICE': 'Intercontinental Exchange',
  'SPGI': 'S&P Global Inc.',
  'MCO': 'Moody\'s Corp.',
  'MSCI': 'MSCI Inc.',
  'FIS': 'Fidelity National Info',
  'FISV': 'Fiserv Inc.',
  'ADP': 'Automatic Data Processing',
  'PYPL': 'PayPal Holdings Inc.',
  'SOFI': 'SoFi Technologies Inc.',
  'AFRM': 'Affirm Holdings',
  'NU': 'Nu Holdings Ltd.',
  'MELI': 'MercadoLibre Inc.',
  'BRK.A': 'Berkshire Hathaway (A)',
  'BRK.B': 'Berkshire Hathaway (B)',
  'MMC': 'Marsh & McLennan',
  'AON': 'Aon plc',
  'CB': 'Chubb Limited',
  'AIG': 'American International Group',
  'MET': 'MetLife Inc.',
  'PRU': 'Prudential Financial',
  'ALL': 'Allstate Corp.',
  'TRV': 'Travelers Companies',
  'AFL': 'Aflac Inc.',
  'CINF': 'Cincinnati Financial',
  'RE': 'Everest Group Ltd.',

  // ========================
  // HEALTHCARE & PHARMA
  // ========================
  'UNH': 'UnitedHealth Group',
  'JNJ': 'Johnson & Johnson',
  'LLY': 'Eli Lilly and Co.',
  'PFE': 'Pfizer Inc.',
  'ABBV': 'AbbVie Inc.',
  'MRK': 'Merck & Co. Inc.',
  'TMO': 'Thermo Fisher Scientific',
  'ABT': 'Abbott Laboratories',
  'DHR': 'Danaher Corp.',
  'BMY': 'Bristol-Myers Squibb',
  'AMGN': 'Amgen Inc.',
  'GILD': 'Gilead Sciences Inc.',
  'ISRG': 'Intuitive Surgical',
  'VRTX': 'Vertex Pharmaceuticals',
  'REGN': 'Regeneron Pharmaceuticals',
  'SYK': 'Stryker Corp.',
  'BDX': 'Becton Dickinson',
  'MDT': 'Medtronic plc',
  'BSX': 'Boston Scientific',
  'EW': 'Edwards Lifesciences',
  'ZTS': 'Zoetis Inc.',
  'CI': 'The Cigna Group',
  'ELV': 'Elevance Health',
  'HUM': 'Humana Inc.',
  'CNC': 'Centene Corp.',
  'MCK': 'McKesson Corp.',
  'CAH': 'Cardinal Health',
  'ABC': 'Cencora Inc.',
  'HCA': 'HCA Healthcare',
  'DXCM': 'DexCom Inc.',
  'IQV': 'IQVIA Holdings',
  'A': 'Agilent Technologies',
  'BIIB': 'Biogen Inc.',
  'MRNA': 'Moderna Inc.',
  'BNTX': 'BioNTech SE',
  'ILMN': 'Illumina Inc.',
  'HOLX': 'Hologic Inc.',
  'ALGN': 'Align Technology',
  'PODD': 'Insulet Corp.',

  // ========================
  // CONSUMER DISCRETIONARY
  // ========================
  'HD': 'Home Depot Inc.',
  'LOW': 'Lowe\'s Companies',
  'TGT': 'Target Corp.',
  'TJX': 'TJX Companies',
  'ROST': 'Ross Stores Inc.',
  'NKE': 'Nike Inc.',
  'LULU': 'Lululemon Athletica',
  'SBUX': 'Starbucks Corp.',
  'MCD': 'McDonald\'s Corp.',
  'DIS': 'Walt Disney Co.',
  'NFLX': 'Netflix Inc.',
  'ABNB': 'Airbnb Inc.',
  'BKNG': 'Booking Holdings',
  'MAR': 'Marriott International',
  'HLT': 'Hilton Worldwide',
  'EXPE': 'Expedia Group',
  'LVS': 'Las Vegas Sands',
  'WYNN': 'Wynn Resorts',
  'MGM': 'MGM Resorts Intl.',
  'CMG': 'Chipotle Mexican Grill',
  'DPZ': 'Domino\'s Pizza',
  'YUM': 'Yum! Brands Inc.',
  'QSR': 'Restaurant Brands Intl.',
  'DKNG': 'DraftKings Inc.',
  'F': 'Ford Motor Co.',
  'GM': 'General Motors Co.',
  'RIVN': 'Rivian Automotive',
  'LCID': 'Lucid Group Inc.',
  'STLA': 'Stellantis NV',
  'TM': 'Toyota Motor Corp.',
  'HMC': 'Honda Motor Co.',
  'RACE': 'Ferrari NV',
  'ORLY': 'O\'Reilly Automotive',
  'AZO': 'AutoZone Inc.',
  'AAP': 'Advance Auto Parts',
  'KMX': 'CarMax Inc.',
  'CVNA': 'Carvana Co.',
  'EBAY': 'eBay Inc.',
  'ETSY': 'Etsy Inc.',
  'W': 'Wayfair Inc.',
  'RH': 'RH (Restoration Hardware)',
  'DECK': 'Deckers Outdoor',
  'CROX': 'Crocs Inc.',
  'BIRD': 'Allbirds Inc.',
  'CHWY': 'Chewy Inc.',
  'PTON': 'Peloton Interactive',
  'DHI': 'D.R. Horton Inc.',
  'LEN': 'Lennar Corp.',
  'PHM': 'PulteGroup Inc.',
  'TOL': 'Toll Brothers Inc.',

  // ========================
  // CONSUMER STAPLES
  // ========================
  'WMT': 'Walmart Inc.',
  'COST': 'Costco Wholesale Corp.',
  'PG': 'Procter & Gamble Co.',
  'KO': 'Coca-Cola Co.',
  'PEP': 'PepsiCo Inc.',
  'PM': 'Philip Morris Intl.',
  'MO': 'Altria Group Inc.',
  'MDLZ': 'Mondelez Intl.',
  'CL': 'Colgate-Palmolive',
  'KHC': 'Kraft Heinz Co.',
  'GIS': 'General Mills Inc.',
  'K': 'Kellanova',
  'HSY': 'Hershey Co.',
  'SJM': 'J.M. Smucker Co.',
  'MNST': 'Monster Beverage',
  'STZ': 'Constellation Brands',
  'SAM': 'Boston Beer Co.',
  'TAP': 'Molson Coors Brewing',
  'EL': 'Estée Lauder Cos.',
  'CLX': 'Clorox Co.',
  'CHD': 'Church & Dwight',
  'KMB': 'Kimberly-Clark',
  'KR': 'Kroger Co.',
  'SYY': 'Sysco Corp.',
  'ADM': 'Archer-Daniels-Midland',
  'BG': 'Bunge Global SA',

  // ========================
  // INDUSTRIALS
  // ========================
  'CAT': 'Caterpillar Inc.',
  'DE': 'Deere & Company',
  'BA': 'Boeing Co.',
  'RTX': 'RTX Corp.',
  'LMT': 'Lockheed Martin',
  'NOC': 'Northrop Grumman',
  'GD': 'General Dynamics',
  'GE': 'GE Aerospace',
  'HON': 'Honeywell Intl.',
  'MMM': 'Minnesota Mining (3M)',
  'UPS': 'United Parcel Service',
  'FDX': 'FedEx Corp.',
  'UNP': 'Union Pacific Corp.',
  'CSX': 'CSX Corp.',
  'NSC': 'Norfolk Southern',
  'DAL': 'Delta Air Lines',
  'UAL': 'United Airlines Holdings',
  'LUV': 'Southwest Airlines',
  'AAL': 'American Airlines',
  'JBLU': 'JetBlue Airways',
  'EMR': 'Emerson Electric',
  'ETN': 'Eaton Corp.',
  'ROK': 'Rockwell Automation',
  'DOV': 'Dover Corp.',
  'SWK': 'Stanley Black & Decker',
  'IR': 'Ingersoll Rand',
  'PH': 'Parker-Hannifin',
  'CARR': 'Carrier Global',
  'OTIS': 'Otis Worldwide',
  'WM': 'Waste Management',
  'RSG': 'Republic Services',
  'CTAS': 'Cintas Corp.',
  'FAST': 'Fastenal Co.',
  'AXON': 'Axon Enterprise',
  'TT': 'Trane Technologies',
  'PCAR': 'PACCAR Inc.',
  'CMI': 'Cummins Inc.',
  'GNRC': 'Generac Holdings',
  'UBER': 'Uber Technologies',
  'LYFT': 'Lyft Inc.',

  // ========================
  // ENERGY
  // ========================
  'XOM': 'Exxon Mobil Corp.',
  'CVX': 'Chevron Corp.',
  'COP': 'ConocoPhillips',
  'EOG': 'EOG Resources',
  'SLB': 'Schlumberger Ltd.',
  'MPC': 'Marathon Petroleum',
  'PSX': 'Phillips 66',
  'VLO': 'Valero Energy Corp.',
  'OXY': 'Occidental Petroleum',
  'HES': 'Hess Corp.',
  'DVN': 'Devon Energy Corp.',
  'FANG': 'Diamondback Energy',
  'PXD': 'Pioneer Natural Resources',
  'HAL': 'Halliburton Co.',
  'BKR': 'Baker Hughes Co.',
  'KMI': 'Kinder Morgan Inc.',
  'WMB': 'Williams Companies',
  'OKE': 'ONEOK Inc.',
  'TRGP': 'Targa Resources',
  'LNG': 'Cheniere Energy',
  'ENPH': 'Enphase Energy',
  'SEDG': 'SolarEdge Technologies',
  'FSLR': 'First Solar Inc.',
  'RUN': 'Sunrun Inc.',
  'PLUG': 'Plug Power Inc.',
  'BE': 'Bloom Energy Corp.',

  // ========================
  // TELECOM & MEDIA
  // ========================
  'T': 'AT&T Inc.',
  'VZ': 'Verizon Communications',
  'TMUS': 'T-Mobile US Inc.',
  'CMCSA': 'Comcast Corp.',
  'CHTR': 'Charter Communications',
  'WBD': 'Warner Bros. Discovery',
  'PARA': 'Paramount Global',
  'FOX': 'Fox Corp.',
  'FOXA': 'Fox Corp. (Class A)',
  'NWSA': 'News Corp.',
  'OMC': 'Omnicom Group',
  'IPG': 'Interpublic Group',

  // ========================
  // REAL ESTATE (REITs)
  // ========================
  'AMT': 'American Tower Corp.',
  'PLD': 'Prologis Inc.',
  'CCI': 'Crown Castle Inc.',
  'EQIX': 'Equinix Inc.',
  'O': 'Realty Income Corp.',
  'SPG': 'Simon Property Group',
  'PSA': 'Public Storage',
  'DLR': 'Digital Realty Trust',
  'WELL': 'Welltower Inc.',
  'AVB': 'AvalonBay Communities',
  'EQR': 'Equity Residential',
  'VICI': 'VICI Properties',
  'ARE': 'Alexandria Real Estate',
  'MAA': 'Mid-America Apartment',
  'UDR': 'UDR Inc.',
  'ESS': 'Essex Property Trust',
  'CPT': 'Camden Property Trust',
  'INVH': 'Invitation Homes',
  'SUI': 'Sun Communities',
  'ELS': 'Equity LifeStyle Properties',

  // ========================
  // UTILITIES
  // ========================
  'NEE': 'NextEra Energy Inc.',
  'DUK': 'Duke Energy Corp.',
  'SO': 'Southern Company',
  'D': 'Dominion Energy',
  'AEP': 'American Electric Power',
  'SRE': 'Sempra',
  'EXC': 'Exelon Corp.',
  'XEL': 'Xcel Energy Inc.',
  'PCG': 'PG&E Corp.',
  'ED': 'Consolidated Edison',
  'WEC': 'WEC Energy Group',
  'ES': 'Eversource Energy',
  'AEE': 'Ameren Corp.',
  'DTE': 'DTE Energy Co.',
  'AWK': 'American Water Works',

  // ========================
  // MATERIALS
  // ========================
  'LIN': 'Linde plc',
  'APD': 'Air Products & Chemicals',
  'SHW': 'Sherwin-Williams Co.',
  'ECL': 'Ecolab Inc.',
  'DD': 'DuPont de Nemours',
  'DOW': 'Dow Inc.',
  'NEM': 'Newmont Corp.',
  'FCX': 'Freeport-McMoRan',
  'NUE': 'Nucor Corp.',
  'STLD': 'Steel Dynamics Inc.',
  'VMC': 'Vulcan Materials',
  'MLM': 'Martin Marietta Materials',
  'ALB': 'Albemarle Corp.',
  'PPG': 'PPG Industries',
  'CTVA': 'Corteva Inc.',
  'CF': 'CF Industries Holdings',
  'MOS': 'Mosaic Co.',
  'GOLD': 'Barrick Gold Corp.',
  'AEM': 'Agnico Eagle Mines',
  'WPM': 'Wheaton Precious Metals',
  'RGLD': 'Royal Gold Inc.',

  // ========================
  // SPACE & DEFENSE TECH
  // ========================
  'RKLB': 'Rocket Lab USA',
  'ASTR': 'Astra Space Inc.',
  'SPCE': 'Virgin Galactic',
  'KTOS': 'Kratos Defense',
  'ASTS': 'AST SpaceMobile',
  'RDW': 'Redwire Corp.',
  'LUNR': 'Intuitive Machines',
  'MNTS': 'Momentus Inc.',
  'LDOS': 'Leidos Holdings',
  'BAH': 'Booz Allen Hamilton',
  'HII': 'Huntington Ingalls Industries',
  'LHX': 'L3Harris Technologies',
  'TDG': 'TransDigm Group',
  'HWM': 'Howmet Aerospace',
  'SPR': 'Spirit AeroSystems',
  'MSTR': 'MicroStrategy Inc.',

  // ========================
  // BIOTECH & GENOMICS
  // ========================
  'CRSP': 'CRISPR Therapeutics',
  'EDIT': 'Editas Medicine',
  'NTLA': 'Intellia Therapeutics',
  'BEAM': 'Beam Therapeutics',
  'EXAS': 'Exact Sciences',
  'RARE': 'Ultragenyx Pharma',
  'SGEN': 'Seagen Inc.',
  'NBIX': 'Neurocrine Biosciences',
  'PCVX': 'Vaxcyte Inc.',
  'ARCT': 'Arcturus Therapeutics',
  'SRPT': 'Sarepta Therapeutics',
  'BMRN': 'BioMarin Pharmaceutical',

  // ========================
  // POPULAR ETFs
  // ========================
  'SPY': 'SPDR S&P 500 ETF Trust',
  'VOO': 'Vanguard S&P 500 ETF',
  'IVV': 'iShares Core S&P 500 ETF',
  'VTI': 'Vanguard Total Stock Market ETF',
  'QQQ': 'Invesco QQQ Trust (Nasdaq-100)',
  'VT': 'Vanguard Total World Stock ETF',
  'DIA': 'SPDR Dow Jones Industrial ETF',
  'IWM': 'iShares Russell 2000 ETF',
  'IWF': 'iShares Russell 1000 Growth ETF',
  'IWD': 'iShares Russell 1000 Value ETF',
  'ARKK': 'ARK Innovation ETF',
  'ARKW': 'ARK Next Generation Internet ETF',
  'ARKG': 'ARK Genomic Revolution ETF',
  'ARKF': 'ARK Fintech Innovation ETF',
  'SCHD': 'Schwab US Dividend Equity ETF',
  'VYM': 'Vanguard High Dividend Yield ETF',
  'VIG': 'Vanguard Dividend Appreciation ETF',
  'DVY': 'iShares Select Dividend ETF',
  'DGRO': 'iShares Core Dividend Growth ETF',
  'HDV': 'iShares Core High Dividend ETF',
  'VEA': 'Vanguard FTSE Developed Markets ETF',
  'VWO': 'Vanguard FTSE Emerging Markets ETF',
  'EEM': 'iShares MSCI Emerging Markets ETF',
  'IEFA': 'iShares Core MSCI EAFE ETF',
  'EFA': 'iShares MSCI EAFE ETF',
  'IXUS': 'iShares Core MSCI Total Intl Stock ETF',
  'AGG': 'iShares Core US Aggregate Bond ETF',
  'BND': 'Vanguard Total Bond Market ETF',
  'TLT': 'iShares 20+ Year Treasury Bond ETF',
  'SHY': 'iShares 1-3 Year Treasury Bond ETF',
  'IEF': 'iShares 7-10 Year Treasury Bond ETF',
  'LQD': 'iShares iBoxx Investment Grade Bond ETF',
  'HYG': 'iShares iBoxx High Yield Bond ETF',
  'JNK': 'SPDR Bloomberg High Yield Bond ETF',
  'GLD': 'SPDR Gold Shares',
  'IAU': 'iShares Gold Trust',
  'SLV': 'iShares Silver Trust',
  'USO': 'United States Oil Fund',
  'VNQ': 'Vanguard Real Estate ETF',
  'SCHH': 'Schwab US REIT ETF',
  'XLK': 'Technology Select Sector SPDR',
  'XLV': 'Health Care Select Sector SPDR',
  'XLF': 'Financial Select Sector SPDR',
  'XLE': 'Energy Select Sector SPDR',
  'XLI': 'Industrial Select Sector SPDR',
  'XLY': 'Consumer Discretionary Select Sector SPDR',
  'XLP': 'Consumer Staples Select Sector SPDR',
  'XLU': 'Utilities Select Sector SPDR',
  'XLRE': 'Real Estate Select Sector SPDR',
  'XLC': 'Communication Services Select Sector SPDR',
  'XLB': 'Materials Select Sector SPDR',
  'TQQQ': 'ProShares UltraPro QQQ (3x)',
  'SQQQ': 'ProShares UltraPro Short QQQ (-3x)',
  'SPXL': 'Direxion Daily S&P 500 Bull 3X',
  'SPXS': 'Direxion Daily S&P 500 Bear 3X',
  'SOXL': 'Direxion Daily Semiconductor Bull 3X',
  'SOXS': 'Direxion Daily Semiconductor Bear 3X',
  'UVXY': 'ProShares Ultra VIX Short-Term Futures',
  'VXX': 'iPath Series B S&P 500 VIX Short-Term',
  'KWEB': 'KraneShares CSI China Internet ETF',
  'MCHI': 'iShares MSCI China ETF',
  'FXI': 'iShares China Large-Cap ETF',
  'EWJ': 'iShares MSCI Japan ETF',
  'EWT': 'iShares MSCI Taiwan ETF',
  'EWZ': 'iShares MSCI Brazil ETF',
  'INDA': 'iShares MSCI India ETF',
  'THD': 'iShares MSCI Thailand ETF',
  'SMH': 'VanEck Semiconductor ETF',
  'SOXX': 'iShares Semiconductor ETF',
  'XBI': 'SPDR S&P Biotech ETF',
  'IBB': 'iShares Biotechnology ETF',
  'JETS': 'US Global Jets ETF',
  'TAN': 'Invesco Solar ETF',
  'ICLN': 'iShares Global Clean Energy ETF',
  'HACK': 'ETFMG Prime Cyber Security ETF',
  'BOTZ': 'Global X Robotics & AI ETF',
  'ROBO': 'Robo Global Robotics and Automation ETF',

  // ========================
  // INCOME & COVERED CALL ETFs
  // ========================
  'JEPI': 'JPMorgan Equity Premium Income ETF',
  'JEPQ': 'JPMorgan Nasdaq Equity Premium Income ETF',
  'DIVO': 'Amplify CWP Enhanced Dividend Income ETF',
  'QQQI': 'NEOS Nasdaq-100 High Income ETF',
  'SPYI': 'NEOS S&P 500 High Income ETF',
  'QYLD': 'Global X NASDAQ 100 Covered Call ETF',
  'XYLD': 'Global X S&P 500 Covered Call ETF',
  'RYLD': 'Global X Russell 2000 Covered Call ETF',
  'NUSI': 'Nationwide Nasdaq-100 Risk-Managed Income ETF',
  'SVOL': 'Simplify Volatility Premium ETF',
  'PFFD': 'Global X U.S. Preferred ETF',
  'PFF': 'iShares Preferred and Income Securities ETF',
  'HYGW': 'iShares High Yield Bond BuyWrite Strategy ETF',
  'TLTW': 'iShares 20+ Year Treasury Bond BuyWrite Strategy ETF',
  'GPIQ': 'Goldman Sachs Nasdaq-100 Core Premium Income ETF',
  'GPIX': 'Goldman Sachs S&P 500 Core Premium Income ETF',

  // ========================
  // BITCOIN & CRYPTO ETFs
  // ========================
  'IBIT': 'iShares Bitcoin Trust ETF',
  'FBTC': 'Fidelity Wise Origin Bitcoin Fund',
  'GBTC': 'Grayscale Bitcoin Trust',
  'BITO': 'ProShares Bitcoin Strategy ETF',
  'ARKB': 'ARK 21Shares Bitcoin ETF',
  'BITB': 'Bitwise Bitcoin ETF',
  'ETHE': 'Grayscale Ethereum Trust',
  'ETHA': 'iShares Ethereum Trust ETF',

  // ========================
  // GROWTH, VALUE & CORE ETFs
  // ========================
  'QQQM': 'Invesco Nasdaq 100 ETF',
  'SPLG': 'SPDR Portfolio S&P 500 ETF',
  'SCHG': 'Schwab US Large-Cap Growth ETF',
  'SCHX': 'Schwab US Large-Cap ETF',
  'VOOG': 'Vanguard S&P 500 Growth ETF',
  'VOOV': 'Vanguard S&P 500 Value ETF',
  'RSP': 'Invesco S&P 500 Equal Weight ETF',
  'COWZ': 'Pacer US Cash Cows 100 ETF',
  'MOAT': 'VanEck Morningstar Wide Moat ETF',
  'VXUS': 'Vanguard Total International Stock ETF',
  'FTEC': 'Fidelity MSCI Information Technology Index ETF',
  'MGK': 'Vanguard Mega Cap Growth ETF',
  'VUG': 'Vanguard Growth ETF',
  'VTV': 'Vanguard Value ETF',
  'VCIT': 'Vanguard Intermediate-Term Corporate Bond ETF',
  'VCSH': 'Vanguard Short-Term Corporate Bond ETF',
  'VTIP': 'Vanguard Short-Term Inflation-Protected Securities ETF',
  'SGOV': 'iShares 0-3 Month Treasury Bond ETF',
  'BIL': 'SPDR Bloomberg 1-3 Month T-Bill ETF',

  // ========================
  // INTERNATIONAL ADRs
  // ========================
  'BABA': 'Alibaba Group',
  'JD': 'JD.com Inc.',
  'PDD': 'PDD Holdings (Pinduoduo)',
  'BIDU': 'Baidu Inc.',
  'NIO': 'NIO Inc.',
  'LI': 'Li Auto Inc.',
  'XPEV': 'XPeng Inc.',
  'BILI': 'Bilibili Inc.',
  'TME': 'Tencent Music',
  'VNET': 'VNET Group Inc.',
  'WB': 'Weibo Corp.',
  'ZTO': 'ZTO Express',
  'TAL': 'TAL Education Group',
  'TM': 'Toyota Motor Corp.',
  'HMC': 'Honda Motor Co. Ltd.',
  'SONY': 'Sony Group Corp.',
  'NTDOY': 'Nintendo Co. Ltd.',
  'SAP': 'SAP SE',
  'RACE': 'Ferrari NV',
  'UL': 'Unilever plc',
  'DEO': 'Diageo plc',
  'BHP': 'BHP Group Ltd.',
  'RIO': 'Rio Tinto Group',
  'VALE': 'Vale SA',
  'SHEL': 'Shell plc',
  'BP': 'BP plc',
  'TTE': 'TotalEnergies SE',
  'EQNR': 'Equinor ASA',
  'HSBC': 'HSBC Holdings plc',
  'UBS': 'UBS Group AG',
  'CS': 'Credit Suisse Group',
  'DB': 'Deutsche Bank AG',
  'NVO': 'Novo Nordisk A/S',
  'AZN': 'AstraZeneca plc',
  'GSK': 'GSK plc',
  'SNY': 'Sanofi SA',
  'INFY': 'Infosys Limited',
  'WIT': 'Wipro Limited',
  'TCEHY': 'Tencent Holdings',
  'MUFG': 'Mitsubishi UFJ Financial',
  'SMFG': 'Sumitomo Mitsui Financial',

  // ========================
  // CRYPTOCURRENCY
  // ========================
  'BTC': 'Bitcoin',
  'ETH': 'Ethereum',
  'BNB': 'BNB (Binance Coin)',
  'SOL': 'Solana',
  'XRP': 'XRP (Ripple)',
  'ADA': 'Cardano',
  'DOGE': 'Dogecoin',
  'DOT': 'Polkadot',
  'MATIC': 'Polygon',
  'LINK': 'Chainlink',
  'SHIB': 'Shiba Inu',
  'AVAX': 'Avalanche',
  'UNI': 'Uniswap',
  'ATOM': 'Cosmos',
  'LTC': 'Litecoin',
  'BCH': 'Bitcoin Cash',
  'FIL': 'Filecoin',
  'NEAR': 'NEAR Protocol',
  'APT': 'Aptos',
  'ARB': 'Arbitrum',
  'OP': 'Optimism',
  'SUI': 'Sui',
  'SEI': 'Sei Network',
  'INJ': 'Injective',
  'TIA': 'Celestia',
  'PEPE': 'Pepe',
  'WIF': 'dogwifhat',
  'BONK': 'Bonk',
  'RENDER': 'Render Token',
  'FET': 'Fetch.ai',
  'AGIX': 'SingularityNET',
  'RNDR': 'Render Token',
  'GRT': 'The Graph',
  'IMX': 'Immutable X',
  'SAND': 'The Sandbox',
  'MANA': 'Decentraland',
  'AXS': 'Axie Infinity',
  'AAVE': 'Aave',
  'CRV': 'Curve DAO Token',
  'MKR': 'Maker',
  'SNX': 'Synthetix',
  'COMP': 'Compound',
  'ALGO': 'Algorand',
  'VET': 'VeChain',
  'HBAR': 'Hedera',
  'EOS': 'EOS',
  'XTZ': 'Tezos',
  'EGLD': 'MultiversX',
  'THETA': 'Theta Network',
  'ICP': 'Internet Computer',
  'FLOW': 'Flow',
  'MINA': 'Mina Protocol',
  'STX': 'Stacks',
  'ROSE': 'Oasis Network',
  'KDA': 'Kadena',
  'CKB': 'Nervos Network',
  'ZEC': 'Zcash',
  'DASH': 'Dash',
  'XMR': 'Monero',
  'TON': 'Toncoin',
  'TRX': 'TRON',
  'USDT': 'Tether',
  'USDC': 'USD Coin',
  'DAI': 'Dai',
  'BUSD': 'Binance USD',
  'TUSD': 'TrueUSD',

  // ========================
  // GOLD & PRECIOUS METALS
  // ========================
  'XAUUSD': 'Gold Spot (XAU/USD per Troy Ounce)',
  'GOLDTHB': 'Thai Gold (THB per Baht Weight)',
  ...generateDatabaseAliases()
};
